import React, { Component} from "react";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "../../layout/AppLayout";
import crudGrid from './modules/crudGrid';
import admGrades from './modules/custom/admGrades';
import admAttendanceControl from './modules/custom/admAttendanceControl';
import admJustification from './modules/custom/admJustification';
import admCommunications from './modules/custom/admCommunications';
import admConversations from './modules/custom/admConversations';
import admStats from './modules/custom/admStats';
import admUsage from './modules/custom/admUsage';
import modules from "../../config/admModules/modules";
import home from "./home"

class App extends Component {
  constructor(props) {
    super(props);
    this.appModules = () => {
      const searchComponent = (name) => {
        if (['admGrades', 'admGradesBehavior'].indexOf(name) > -1) return admGrades
        else if (name === 'admAttendanceControl') return admAttendanceControl
        else if (name === 'admJustification') return admJustification
        else if (name === 'admCommunications') return admCommunications
        else if (name === 'admConversations') return admConversations
        else if (name === 'admStats') return admStats
        else if (name === 'admUsage') return admUsage
        else return crudGrid
      }

      let r = []
      let otherModules = [
        {id: 'home', component: home}
      ]
      
      this.props.menuItems.forEach(e => {

        if (e.subs && e.subs.length > 0) {
           // submenus
            e.subs.forEach(eee => {
              modules.forEach(eeee => { if (eee.id === eeee.id) r.push({ id: eee.id, component: searchComponent(eee.id) }) });
            });
        }
        else {
           // menus
            modules.forEach(ee => { if (e.id === ee.id) r.push({ id: e.id, component: searchComponent(e.id) }) });
        }
       
        otherModules.forEach(ee => { if (e.id === ee.id) r.push(ee) });
       
      });
      if (!r.find((e) => { return e.id === 'home' })) r.push(otherModules[0])
      return r
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(prevProps)
  }

  render() {
    const { match } = this.props;
    return (
      <AppLayout>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/home`} />
            {this.appModules().filter(f=>!f.hidden).map(e => {
              return  ( <Route key={e.id} path={`${match.url}/${e.id}`} component={e.component} /> )
            })}
          <Redirect to="/error" />
        </Switch>
      </AppLayout>
    );
  }
}
const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuItems } = menu;
  return { containerClassnames, menuItems };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
);
